var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.showModal
        ? _c(
            "transition",
            {
              attrs: {
                name: "custom-classes-transition",
                "enter-active-class": "animated bounceInLeft",
                "leave-active-class": "animated bounceOutRight",
              },
            },
            [
              _c("div", { staticClass: "detail-modal" }, [
                _c(
                  "div",
                  {
                    staticClass: "close-show-detail",
                    staticStyle: {
                      position: "absolute",
                      right: "10px",
                      "z-index": "10000",
                    },
                    on: { click: _vm.closeModal },
                  },
                  [
                    _c("eva-icon", {
                      attrs: {
                        name: "close-circle",
                        fill: "#FFF",
                        width: "50",
                        height: "50",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "progress-job-list-box" },
                  [
                    _vm.showRecord &&
                    _vm.UserId !== "00000000-0000-0000-0000-000000000000"
                      ? [
                          _c(
                            "perfect-scrollbar",
                            { staticClass: "progress-job-list" },
                            _vm._l(_vm.recordList, function (record) {
                              return _c(
                                "div",
                                {
                                  key: record.index,
                                  staticClass: "job-item",
                                  class: {
                                    active:
                                      record.MatchId === _vm.jobRecordMatchId,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.clickRecord(record.MatchId)
                                    },
                                  },
                                },
                                [
                                  _c("div", { staticClass: "time" }, [
                                    _c("div", { staticClass: "status" }, [
                                      _vm._v(_vm._s(record.InterviewResult)),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "info" }, [
                                    _c("div", { staticClass: "job-name" }, [
                                      _vm._v(_vm._s(record.ManpowerDemandName)),
                                    ]),
                                    _c("div", { staticClass: "d-number" }, [
                                      _vm._v(_vm._s(record.ManpowerDemandNo)),
                                    ]),
                                  ]),
                                ]
                              )
                            }),
                            0
                          ),
                          _vm.showProgress
                            ? _c(
                                "perfect-scrollbar",
                                { staticClass: "timeline" },
                                [
                                  _c(
                                    "ul",
                                    [
                                      _c("li", { staticClass: "welcome" }, [
                                        _c("div", [_vm._v(_vm._s(_vm.Name))]),
                                        _c("span", [_vm._v("求職歷程")]),
                                      ]),
                                      _vm._l(
                                        _vm.jobHistoryList,
                                        function (history) {
                                          return _c(
                                            "li",
                                            { key: history.index },
                                            [
                                              _c(
                                                "div",
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "icon-wrap",
                                                    },
                                                    [
                                                      _c("eva-icon", {
                                                        attrs: {
                                                          fill: "#FFF",
                                                          name: "pricetags-outline",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  history.TypeName ===
                                                  "WriteResume"
                                                    ? [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "time-wrap",
                                                          },
                                                          [
                                                            _c("h4", [
                                                              _c("strong", [
                                                                _vm._v(
                                                                  "應聘者履歷"
                                                                ),
                                                              ]),
                                                            ]),
                                                          ]
                                                        ),
                                                      ]
                                                    : [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "time-wrap",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  history.OccurDate
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "text-wrap",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                history.Status
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "button-wrap",
                                                          },
                                                          [
                                                            history.Status ===
                                                            "面談結果-複試"
                                                              ? [
                                                                  _c(
                                                                    "button",
                                                                    {
                                                                      staticClass:
                                                                        "btn",
                                                                      attrs: {
                                                                        type: "button",
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.viewInterview(
                                                                              history.InterviewId
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " 檢視面談紀錄 "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "button",
                                                                    {
                                                                      staticClass:
                                                                        "btn",
                                                                      staticStyle:
                                                                        {
                                                                          "margin-left":
                                                                            "10px",
                                                                        },
                                                                      attrs: {
                                                                        type: "button",
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.openInterviewProgress(
                                                                              _vm.MatchId
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " 檢視面談紀錄歷程 "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              : _vm._e(),
                                                          ],
                                                          2
                                                        ),
                                                      ],
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "button-wrap",
                                                    },
                                                    [
                                                      history.TypeName ===
                                                      "WriteResume"
                                                        ? _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "btn",
                                                              attrs: {
                                                                type: "button",
                                                              },
                                                              on: {
                                                                click:
                                                                  _vm.viewResume,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " 檢視履歷 "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      history.TypeName ===
                                                      "InterviewInvitation"
                                                        ? _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "btn",
                                                              attrs: {
                                                                type: "button",
                                                                "data-toggle":
                                                                  "modal",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.openInterviewMail(
                                                                      history.InterviewId
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " 檢視邀約信件 "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      history.TypeName ===
                                                      "ThanksNotice"
                                                        ? [
                                                            _c(
                                                              "button",
                                                              {
                                                                staticClass:
                                                                  "btn",
                                                                attrs: {
                                                                  type: "button",
                                                                  "data-toggle":
                                                                    "modal",
                                                                },
                                                                on: {
                                                                  click:
                                                                    _vm.openThanksMail,
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " 檢視感謝函 "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        : _vm._e(),
                                                      history.TypeName ===
                                                      "HireNotice"
                                                        ? _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "btn",
                                                              attrs: {
                                                                type: "button",
                                                                "data-toggle":
                                                                  "modal",
                                                              },
                                                              on: {
                                                                click:
                                                                  _vm.openHiredMail,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " 檢視錄取信件 "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      history.TypeName ===
                                                      "ReportNotice"
                                                        ? _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "btn",
                                                              attrs: {
                                                                type: "button",
                                                                "data-toggle":
                                                                  "modal",
                                                              },
                                                              on: {
                                                                click:
                                                                  _vm.openReportedMail,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " 檢視報到信件 "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    2
                                                  ),
                                                ],
                                                2
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      : _vm._e(),
                    !_vm.showRecord ||
                    _vm.UserId === "00000000-0000-0000-0000-000000000000"
                      ? [
                          _c("section", [
                            _c("div", { staticClass: "notice" }, [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/img/no_record.png"),
                                  alt: "",
                                },
                              }),
                              _c("p", [
                                _vm._v(_vm._s(_vm.Name) + "尚未應徵任何職缺"),
                              ]),
                            ]),
                          ]),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ]),
            ]
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "modal fade bd-example-modal-xl",
          attrs: { id: "mailModal", tabindex: "-1" },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg",
            },
            [
              _c(
                "div",
                { staticClass: "modal-content" },
                [
                  _c("perfect-scrollbar", { staticClass: "modal-body" }, [
                    _c("div", { staticClass: "title" }, [
                      _c("h2", [
                        _c("i", {
                          staticClass: "fa fa-briefcase icon1",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v("Interview Invitation Letter"),
                        ]),
                      ]),
                      _c("h4", [_vm._v(_vm._s(_vm.mailContent.Subject))]),
                    ]),
                    _c("div", { staticClass: "form-content" }, [
                      _c("p", {
                        domProps: { innerHTML: _vm._s(_vm.mailContent.Body) },
                      }),
                    ]),
                  ]),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "historyModal",
            tabindex: "-1",
            "data-backdrop": "static",
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable",
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _vm._m(0),
                _c(
                  "div",
                  { staticClass: "modal-body" },
                  [
                    _c(
                      "div",
                      { staticClass: "evaluation-person-info" },
                      [
                        _c("div", [
                          _c("label", { attrs: { for: "" } }, [_vm._v("姓名")]),
                          _c("div", [
                            _vm._v(_vm._s(_vm.interviewList.Interviewee)),
                          ]),
                        ]),
                        _c("div", [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("面談日期"),
                          ]),
                          _c("div", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$common.dateFormatter(
                                    _vm.interviewList.InterviewDate
                                  )
                                ) +
                                " "
                            ),
                          ]),
                        ]),
                        _vm._l(_vm.interviewList.Scores, function (score) {
                          return _c("div", { key: score.Seq }, [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v(_vm._s(score.Name)),
                            ]),
                            _c("div", [
                              _vm._v(
                                _vm._s(score.OriginScore) +
                                  "/" +
                                  _vm._s(score.Score)
                              ),
                            ]),
                          ])
                        }),
                      ],
                      2
                    ),
                    _vm.interviewList.InterviewRecords &&
                    _vm.interviewList.InterviewRecords.length > 0
                      ? [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "margin-top": "2px",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "evaluation-body fixed" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "evaluation-name" },
                                    [_vm._v("單位面試主管")]
                                  ),
                                  _vm._l(
                                    _vm.interviewList.InterviewRecords[0]
                                      .InterviewRecordAppraisals,
                                    function (item) {
                                      return _c(
                                        "div",
                                        {
                                          key: item.Name,
                                          staticClass: "evaluation-field",
                                        },
                                        [_vm._v(" " + _vm._s(item.Name) + " ")]
                                      )
                                    }
                                  ),
                                  _vm.interviewList.ResumeType === "IDL"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "evaluation-field" },
                                          [_vm._v("職等")]
                                        ),
                                      ]
                                    : _vm._e(),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "evaluation-field",
                                      staticStyle: {
                                        height: "150px",
                                        "overflow-y": "auto",
                                      },
                                    },
                                    [_vm._v(" 面談說明 ")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "evaluation-field",
                                      staticStyle: {
                                        height: "150px",
                                        "overflow-y": "auto",
                                      },
                                    },
                                    [_vm._v(" 個人備註 ")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "evaluation-field",
                                      staticStyle: {
                                        "border-bottom": "0.1px solid",
                                        "border-bottom-color": "#dfdfdf",
                                      },
                                    },
                                    [_vm._v(" 面談結果 ")]
                                  ),
                                ],
                                2
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    flex: "1",
                                    "min-width": "1px",
                                  },
                                },
                                [
                                  _c(
                                    "carousel",
                                    {
                                      key: Math.random(),
                                      attrs: {
                                        items:
                                          _vm.interviewList.InterviewRecords
                                            .length,
                                        nav: true,
                                        dots: false,
                                      },
                                    },
                                    _vm._l(
                                      _vm.interviewList.InterviewRecords,
                                      function (record) {
                                        return _c(
                                          "div",
                                          {
                                            key: record.InterviewSupervisorId,
                                            staticClass: "evaluation-body",
                                            on: {
                                              dblclick: function ($event) {
                                                return _vm.$common.copyText(
                                                  $event
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "evaluation-name",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      record.InterviewSupervisor
                                                    ) +
                                                    " (" +
                                                    _vm._s(
                                                      record.InterviewUserType
                                                    ) +
                                                    ") "
                                                ),
                                              ]
                                            ),
                                            _vm._l(
                                              record.InterviewRecordAppraisals,
                                              function (item) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: item.Name,
                                                    staticClass:
                                                      "evaluation-field",
                                                  },
                                                  [
                                                    item.Result !== "-" &&
                                                    item.Result !== "未填寫"
                                                      ? [
                                                          item.Remark
                                                            ? _c(
                                                                "el-tooltip",
                                                                {
                                                                  staticClass:
                                                                    "item",
                                                                  attrs: {
                                                                    effect:
                                                                      "dark",
                                                                    content:
                                                                      item.Remark,
                                                                    placement:
                                                                      "right",
                                                                  },
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          item.Result
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]),
                                                                ]
                                                              )
                                                            : _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.Result
                                                                  )
                                                                ),
                                                              ]),
                                                        ]
                                                      : _c("span", [
                                                          _vm._v(
                                                            _vm._s(item.Result)
                                                          ),
                                                        ]),
                                                  ],
                                                  2
                                                )
                                              }
                                            ),
                                            _vm.interviewList.ResumeType ===
                                            "IDL"
                                              ? [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "evaluation-field",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            record.ExpectedJobLevel
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              : _vm._e(),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "evaluation-field",
                                                staticStyle: {
                                                  height: "150px",
                                                  "overflow-y": "auto",
                                                },
                                              },
                                              [
                                                _c("div", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(record.Remark) +
                                                      " "
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "evaluation-field",
                                                staticStyle: {
                                                  height: "150px",
                                                  "overflow-y": "auto",
                                                },
                                              },
                                              [
                                                _c("div", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        record.PersonalRemark
                                                      ) +
                                                      " "
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "evaluation-field",
                                                staticStyle: {
                                                  "border-bottom":
                                                    "0.1px solid",
                                                  "border-bottom-color":
                                                    "#dfdfdf",
                                                },
                                              },
                                              [
                                                _c("div", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        record.InterviewResult
                                                      ) +
                                                      " "
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ],
                                          2
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._m(1),
              ]),
            ]
          ),
        ]
      ),
      _c("InterviewProgress", {
        ref: "interviewProgressRef",
        attrs: { MatchId: _vm.MatchId },
      }),
      _c(
        "div",
        {
          staticClass: "modal fade bd-example-modal-lg",
          attrs: {
            id: "resumeModal",
            tabindex: "-1",
            "data-backdrop": "static",
          },
        },
        [
          _c("div", { staticClass: "modal-dialog" }, [
            _c(
              "div",
              { staticClass: "modal-content progress-resume-modal" },
              [
                _c("div", { staticClass: "modal-header" }, [_vm._v("履歷")]),
                _c(
                  "perfect-scrollbar",
                  { staticClass: "modal-body" },
                  [
                    _vm.showDLResume
                      ? _c("DlResume", { attrs: { ResumeId: _vm.ResumeId } })
                      : _vm._e(),
                    _vm.showIDLResume
                      ? _c("IdlResume", { attrs: { ResumeId: _vm.ResumeId } })
                      : _vm._e(),
                  ],
                  1
                ),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button" },
                      on: { click: _vm.hideResume },
                    },
                    [_vm._v(" 關閉 ")]
                  ),
                ]),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c("span", [_vm._v("面談紀錄歷程")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-secondary",
          attrs: { type: "button", "data-dismiss": "modal" },
        },
        [_vm._v(" 關閉 ")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }